import React, { PureComponent } from 'react';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { decorators, DataRow, getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';

// ducks
import { paginateThis } from '../../ducks/CommunitySearch';

// components
import LoadError from '../../components/load-error/load-error';

// contianers
import CommunitySearchResult from './CommunitySearchResult';

// modules
import BS from '../../theme/Bootstrap';

class CommunitySearchResults extends PureComponent {
  render() {
    const { ids, className, isLoading, loadError, reload } = this.props;

    return (
      <div>
        <Table className={cx(className, BS.flex1, BS.positionRelative)}>
          <tbody>
            {ids.map((id, i) => {
              return (
                <DataRow
                  itemId={id}
                  component={CommunitySearchResult}
                  index={i}
                  key={i}
                />
              );
            })}
            {loadError && !isLoading && (
              <tr>
                <td>
                  <LoadError error={loadError} retry={reload} />
                </td>
              </tr>
            )}
            {ids.length === 0 && !isLoading && !loadError && (
              <tr className={`${BS.mb3} ${BS.textCenter}`}>
                <td>No Results</td>
              </tr>
            )}
          </tbody>
        </Table>
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </div>
    );
  }
}

export default decorators.tabulateLean(
  connect(
    (state, props) => {
      const paginator = getPaginator(props.listId, state),
        loadError = paginator.get('loadError');

      return {
        loadError
      };
    },
    {
      reload: paginateThis.pageActions.reload
    }
  )(CommunitySearchResults)
);



// WEBPACK FOOTER //
// ./src/containers/CommunitySearch/CommunitySearchResults.js